// Auto generated file, do not manually modify!
// com.hotpads.idverification.handler.web.IdVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  AcceptTermsWebApiRequestDto,
  GetTermSetWebApiResponseDto,
  IsUserIdentifiedResponseDto,
  PerformIdentifyCheckRequestDto,
  PerformIdentifyCheckResponseDto,
  SubmitIdentityCheckAnswersForPassiveAuthRequestDto,
  SubmitIdentityCheckAnswersResponseDto,
  TermSetId,
  ZgAuthZone,
} from '../..';

interface GetTermSetParams {
  termSetId: TermSetId;
}
interface IsUserIdentifiedParams {
  requestingClient: string;
  zgAuthZone: ZgAuthZone;
}

export const IdVerificationWebApiHandler_acceptTerms_Path = '/api/web/v1/acceptTerms';

export const IdVerificationWebApiHandler_acceptTerms = (
  postData: AcceptTermsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, AcceptTermsWebApiRequestDto, void>(
    {
      endpoint: IdVerificationWebApiHandler_acceptTerms_Path,
      method: 'POST',
      contextPath: '/id-verification',
      postData: postData,
    },
    client,
  );
};

export const IdVerificationWebApiHandler_getTermSet_Path = '/api/web/v1/getTermSet';

export const IdVerificationWebApiHandler_getTermSet = (getParams: GetTermSetParams, client = getClient()) => {
  return httpFrontEndRequest<GetTermSetParams, never, GetTermSetWebApiResponseDto>(
    {
      getParams: getParams,
      endpoint: IdVerificationWebApiHandler_getTermSet_Path,
      method: 'GET',
      contextPath: '/id-verification',
    },
    client,
  );
};

export const IdVerificationWebApiHandler_isIpAddressInTheUs_Path = '/api/web/v1/isIpAddressInTheUs';

export const IdVerificationWebApiHandler_isIpAddressInTheUs = (client = getClient()) => {
  return httpFrontEndRequest<never, never, boolean>(
    {
      endpoint: IdVerificationWebApiHandler_isIpAddressInTheUs_Path,
      method: 'GET',
      contextPath: '/id-verification',
    },
    client,
  );
};

export const IdVerificationWebApiHandler_isUserIdentified_Path = '/api/web/v1/isUserIdentified';

export const IdVerificationWebApiHandler_isUserIdentified = (
  getParams: IsUserIdentifiedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsUserIdentifiedParams, never, IsUserIdentifiedResponseDto>(
    {
      getParams: getParams,
      endpoint: IdVerificationWebApiHandler_isUserIdentified_Path,
      method: 'GET',
      contextPath: '/id-verification',
    },
    client,
  );
};

export const IdVerificationWebApiHandler_performIdentityCheck_Path = '/api/web/v1/performIdentityCheck';

export const IdVerificationWebApiHandler_performIdentityCheck = (
  postData: PerformIdentifyCheckRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, PerformIdentifyCheckRequestDto, PerformIdentifyCheckResponseDto>(
    {
      endpoint: IdVerificationWebApiHandler_performIdentityCheck_Path,
      method: 'POST',
      contextPath: '/id-verification',
      postData: postData,
    },
    client,
  );
};

export const IdVerificationWebApiHandler_submitIdentityCheckAnswers_Path = '/api/web/v1/submitIdentityCheckAnswers';

export const IdVerificationWebApiHandler_submitIdentityCheckAnswers = (
  postData: SubmitIdentityCheckAnswersForPassiveAuthRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SubmitIdentityCheckAnswersForPassiveAuthRequestDto,
    SubmitIdentityCheckAnswersResponseDto
  >(
    {
      endpoint: IdVerificationWebApiHandler_submitIdentityCheckAnswers_Path,
      method: 'POST',
      contextPath: '/id-verification',
      postData: postData,
    },
    client,
  );
};
